"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

class MultiFormInput extends _react.default.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      value: this.props.value,
      cachedValue: null
    };
  }

  componentDidMount() {
    if (!this.props.value || !this.props.value.length) {
      this.setState({
        value: [{}]
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const _this$props = this.props,
          setValue = _this$props.setValue,
          name = _this$props.name,
          required = _this$props.required;
    const _this$state = this.state,
          value = _this$state.value,
          cachedValue = _this$state.cachedValue; // Bind component state to Form's field state.

    if (prevState.value !== value) {
      setValue(name, value, required);
    } // Apply initial Value.


    if (!prevProps.value && this.props.value) {
      this.setState(prevState => ({
        value: this.props.value,
        cachedValue: this.props.value
      }));
    } // To prevent unwanted behaviors after deleting an item, force rerender by
    // emptying value, then loading it up again.


    if (prevState.value && prevState.value.length > value.length && value.length) {
      this.setState(prevState => ({
        value: [],
        cachedValue: value
      }));
    }

    if (cachedValue) {
      this.setState(prevState => ({
        value: cachedValue,
        cachedValue: null
      }));
    }
  }

  render() {
    const _this$props2 = this.props,
          FormComponentProp = _this$props2.form,
          formProps = _this$props2.formProps,
          MoreComponentProp = _this$props2.moreComponent,
          moreLabel = _this$props2.moreLabel,
          moreComponentProps = _this$props2.moreComponentProps,
          deleteIcon = _this$props2.deleteIcon,
          classes = _this$props2.classes;
    const _this$state2 = this.state,
          value = _this$state2.value,
          cachedValue = _this$state2.cachedValue;
    return _react.default.createElement("div", null, value && value.length && !cachedValue ? value.map((fields, index) => _react.default.createElement("div", {
      className: classes.multiFormInput,
      key: index
    }, _react.default.createElement(FormComponentProp, _extends({
      fields: Object.keys(fields).length ? fields : [],
      onChange: updatedFields => this.setState(prevState => ({
        value: prevState.value.map((item, subIndex) => index !== subIndex ? item : updatedFields)
      })),
      value: value
    }, formProps)), _react.default.createElement("button", {
      className: classes.delete,
      onClick: () => this.setState(prevState => ({
        value: prevState.value.filter((item, prevIndex) => prevIndex !== index)
      })),
      title: "Delete"
    }, deleteIcon))) : null, _react.default.createElement(MoreComponentProp, _extends({
      onClick: () => this.setState(prevState => ({
        value: [...prevState.value, {}]
      }))
    }, moreComponentProps), moreLabel));
  }

}

MultiFormInput.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string]),
  form: _propTypes.default.elementType,
  formProps: _propTypes.default.object,
  moreLabel: _propTypes.default.string,
  moreComponent: _propTypes.default.elementType,
  moreComponentProps: _propTypes.default.object,
  deleteIcon: _propTypes.default.node
};
MultiFormInput.defaultProps = {
  moreLabel: 'Add more',
  moreComponent: _.DefaultButton,
  deleteIcon: 'X'
};

var _default = (0, _.withFormControl)((0, _reactJss.default)(theme => ({
  multiFormInput: {
    display: 'flex',
    '& + &': {
      marginTop: theme.sizes.inputGutterBottom
    },
    '& > *:first-child': {
      flexGrow: 1
    }
  },
  delete: {
    backgroundImage: 'none',
    backgroundColor: theme.colors.inputBorder,
    // lighen
    color: 'white',
    fontSize: theme.typography.inputFontSize,
    padding: 5,
    marginLeft: 15,
    border: 'none',
    borderTopRightRadius: theme.sizes.borderRadius,
    borderBottomRightRadius: theme.sizes.borderRadius,
    cursor: 'pointer',
    [(0, _.breakpoint)(theme.breakpoints.sm)]: {
      marginLeft: 30
    },
    '&:hover': {
      backgroundColor: theme.colors.inputBorder
    }
  }
}))(MultiFormInput));

exports.default = _default;